/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import axios from 'axios'
import { injectable } from 'inversify'
import { IExportRequestApiClient, IExportRequest } from './contracts'
import { SettingsManager } from '../../configuration/SettingsManager'
import { injectProperty } from '../../arc/configuration/ServiceLocator'
import { IUserSessionMiddleware } from '../../arc/middleware/UserSessionMiddleware/contracts'
import { ErrorHelper } from '../../utils/ErrorHelper'

@injectable()
export class ExportRequestApiClient implements IExportRequestApiClient {
	@injectProperty('IUserSessionMiddleware')
	private readonly userSessionMiddleware!: IUserSessionMiddleware

	getTransactionReport(request: IExportRequest): Promise<any> {
		const url = `${SettingsManager.REACT_APP_MAIN_API_BASE_URL().value}/exportablereports`
		return this.userSessionMiddleware
			.loadSessionJwt()
			.then(token =>
				axios.post(url, request, {
					responseType: 'arraybuffer',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}),
			)
			.then(response => response.data)

			.catch(error => {
				ErrorHelper.handleApiError(error)
			})
	}

	sendSelectedTransactionIdsForExportJob(request: IExportRequest): Promise<void> {
		const url = `${SettingsManager.REACT_APP_MAIN_API_BASE_URL().value}/transactionexportrequests/saveTransactionIds`
		return this.userSessionMiddleware
			.loadSessionJwt()
			.then(token =>
				axios.post(url, request, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}),
			)
			.then(response => response.data)

			.catch(error => {
				ErrorHelper.handleApiError(error)
			})
	}

	getGeneratedExportReport(id: number): Promise<any> {
		const url = `${SettingsManager.REACT_APP_MAIN_API_BASE_URL().value}/transactionexportrequests/${id}/generatedReportFile`
		return this.userSessionMiddleware
			.loadSessionJwt()
			.then(token =>
				axios.get(url, {
					responseType: 'arraybuffer',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}),
			)
			.then(response => response.data)

			.catch(error => {
				ErrorHelper.handleApiError(error)
			})
	}
}
